import CurrencyActions from '../../../../actions/CurrencyActions';
import UserInfoActions from '../../../../actions/UserInfoActions';
import UserStore from '../../../../stores/UserStore';
import CustomNotify from '../../../Notify';

export const actions = {
    convertCurrentCurrency(state, onSuccess) {
        const notyNames = UserStore.getTranslation().notyMessages;
        const params = {
            currency: state.currency
        };

        CurrencyActions.convertCurrentCurrency(params, () => {
            UserInfoActions.loadInfo();
            onSuccess && onSuccess();

            CustomNotify(notyNames.update);
        });
    }
};
